import ApplicationAdapter from 'uplisting-frontend/adapters/application';

export default class KnowledgeBaseQaPairAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'ai_knowledge_base_entries';
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'ai-knowledge-base-qa-pair': KnowledgeBaseQaPairAdapter;
  }
}
